import i18n from '@app/i18n';
import { toaster } from '@chakra-primitives/toaster';

export const showScheduledMessageCancelledToast = (): void => {
  toaster.create({
    type: 'info',
    title: i18n.t('scheduledMessageCancelledToast'),
  });
};
